import { Chip } from '@mui/material';
import { useState } from 'react';
import { useNavState } from '../../navState/NavStateContext';
import { UsageList } from './UsageList';
import { WidgetCard } from './WidgetCard';

export const FrequentlyUsedWidget = () => {
  const { readUsage } = useNavState();
  // readUsage() is already sorted by count
  const readFrequent = () => readUsage().slice(0, 8);
  const [entries, setEntries] = useState(readFrequent);

  return (
    <WidgetCard
      title="Frequently Used"
      status={entries.length ? 'READY' : 'EMPTY'}
      emptyText="No recent activity"
      onRefresh={() => setEntries(readFrequent())}
    >
      <UsageList
        entries={entries}
        testId="frequently-used-item"
        renderMeta={(entry) => <Chip size="small" label={entry.count} sx={{ ml: 1 }} />}
      />
    </WidgetCard>
  );
};
